module.exports = __webpack_public_path__ + "assets/img/logo-light.bf3bc892.png";